import "./EmptyNewsieEditor.css";

const EmptyNewsieEditor = ({ newsieInput, takeAwayPoints }) => {
  // let yourDate = new Date();

  return (
    <div className="empty-newsie-editor-container">
      <div className="empty-newsie-content-container">
        <div className='empty-newsie-cta-text-container'>
          Select one of [publications]'s newsies <br />
          or
          <br />
          Create a new one!
        </div>
      </div>
    </div>
  );
};

export default EmptyNewsieEditor;
